(function(angular){
    'use strict';

    angular.module('onvio.setup').factory('TermsSetupManager', termsManager);
    termsManager.$inject = ['$q', '$http', 'AuthenticatedSessionData'];

    function termsManager($q, $http, sessionData){
        var factory = {
            loadTermsAsync: loadTermsAsync,
            loadSampleTextAsync: loadSampleTextAsync,
            saveTermsAsync: saveTermsAsync,
            deleteTermsAsync: deleteTermsAsync,
            convertTermsTextToHtml: convertTermsTextToHtml
        };

        var api = '/api/profiles/v1/companies/';
        var loadedSampleText = [];
        var loadedCompanyId;

        return factory;

        //////////

        function loadTermsAsync(language, terms){
            return makeCrudRequest('GET', language, terms).then(function(data){
                return data;
            }, function(response){
                // 404 = no terms found
                // Note: This will show up in the log
                if(response.status === 404){
                    response.config.global = false;
                    return undefined;
                }

                return $q.reject(response);
            });
        }

        function loadSampleTextAsync(language){
            var deferred = $q.defer();

            // Look to see if the sample text has already been loaded
            if(loadedSampleText.length > 0){
                var loadedSample = loadedSampleText.filter(function(element){
                    return element.code === language;
                });

                if(angular.isDefined(loadedSample) && loadedSample.length === 1){
                    deferred.resolve(loadedSample[0].text);
                    return deferred.promise;
                }
            }

            return makeCrudRequest('GET', language, { id: 'default' }).then(function(data){
                // Cache the sample text
                loadedSampleText.push({
                    code: language,
                    text: data.text
                });

                return data.text;
            });
        }

        function saveTermsAsync(language, terms){
            // If an id is supplied it's really a PUT
            var method = angular.isDefined(terms) && angular.isDefined(terms.id) && terms.id !== '' ? 'PUT' : 'POST';
            return makeCrudRequest(method, language, terms);
        }

        function deleteTermsAsync(language, termsId){
            return makeCrudRequest('DELETE', language, { id: termsId });
        }

        function convertTermsTextToHtml(text){
            return text.replace(/\r\n|\n\r|\n|\r/g, '<br />');
        }

        //////////

        function getSafeLanguage(language){
            // TODO: POSSIBLY VERIFY THAT LANGUAGE IS SUPPORTED FOR USER ENVIRONMENT
            if(angular.isUndefined(language) || language === ''){
                language = 'en-US';
            }

            return language;
        }

        function getCompanyIdAsync(){
            var deferred = $q.defer();

            if(angular.isDefined(loadedCompanyId)){
                deferred.resolve(loadedCompanyId);
                return deferred.promise;
            }

            if(angular.isDefined(sessionData.bindings) && angular.isDefined(sessionData.bindings.ApplicationConfiguration) && angular.isDefined(sessionData.bindings.ApplicationConfiguration.CompanyId)){
                loadedCompanyId = sessionData.bindings.ApplicationConfiguration.CompanyId;
                deferred.resolve(loadedCompanyId);
                return deferred.promise;
            }

            return sessionData.getBindings().then(function(bindings){
                loadedCompanyId = bindings.ApplicationConfiguration.CompanyId;
                return loadedCompanyId;
            });
        }

        function makeCrudRequest(method, language, terms){
            return getCompanyIdAsync().then(function(companyId){
                var completeUrl = api + companyId + '/terms';
                var config = getRequestConfig(method, completeUrl, language);

                if(angular.isDefined(terms)){
                    if(config.method !== 'DELETE' && config.method !== 'GET'){
                        config.data = terms;
                    }

                    if(angular.isDefined(terms.id)){
                        config.url+= '/' + terms.id;
                    }
                }

                return $http(config).then(function(response){
                    return response.data;
                });
            });
        }

        function getRequestConfig(method, url, language){
            return {
                method: method.toUpperCase(),
                url: url,
                headers: {
                    'Accept-Language': getSafeLanguage(language)
                }
            };
        }
    }
})(window.angular);
